// Libs
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router";

// Components
import { Button } from "../../spocketUI";
import CreditCard from "../../../components/_Shared/CreditCard";
import ModalWrapper from "../../../components/_Shared/ModalWrapper";
import { default as Loadable } from "../../../components/_Shared/commonLoadable";

// Actions
import { createPayment } from "../../module/store/customBuild/payment";

// Icons
import visa from "../../images/visa.svg";
import lock from "../../images/icon-lock.svg";
import master from "../../images/mastercard.svg";
import checkmark from "../../images/icon-checkmark.svg";
import radioSelected from "../../images/radio-selected.svg";
import chartIcon from "../../../assets/chart-small-icon.svg";
import americanExpress from "../../images/icon-american-express.svg";
import padlockGreyIcon from "../../../assets/padlock-grey-icon.svg";

// Utils
import { addDaystoCurrentDate } from "../../../utils/date";

// Styles
import "./StoreBuilderPaymentModal.css";

const StoreBuilderPaymentModal = ({
  stripeCustomerId,
  createPayment,
  isFetching,
  allPlans,
}) => {
  const createCreditCardEventSubmit = () => {
    const creditCardForm = document.getElementById("payment-form");

    if (creditCardForm) {
      const event = new Event("submit", { cancelable: true });
      creditCardForm.dispatchEvent(event);
    } else {
      createPayment({ planId: starterPlan().id });
    }
  };

  const starterPlan = () => {
    const plan = allPlans.find(plan => {
      return plan.name === "Starter" && plan.annual === false;
    });

    return plan;
  };

  const renderHeaderModal = () => {
    return (
      <ModalWrapper.Header>
        <div className="StoreBuilderPaymentModal__title-container">
          <img src={chartIcon} alt="chart" />
          <div className="StoreBuilderPaymentModal__title">
            Let us do the hard work!
            <span>
              Grow faster with a custom built store and a Spocket Starter Plan
            </span>
          </div>
        </div>
      </ModalWrapper.Header>
    );
  };

  const renderCreditCardTab = () => {
    return (
      <Tab>
        <div className="StoreBuilderPaymentModal__payment-tab">
          <img src={radioSelected} alt="radioSelected" />
          <div className="StoreBuilderPaymentModal__payment-tab-info">
            Pay with credit/debit card
            <div>
              <img src={visa} alt="Visa" />
              <img src={master} alt="Master" />
              <img src={americanExpress} alt="American Express" />
            </div>
          </div>
        </div>
      </Tab>
    );
  };

  const renderCheckoutButton = () => {
    return (
      <Button
        variant="primaryBig"
        onClick={() => createCreditCardEventSubmit()}
      >
        Claim the offer
      </Button>
    );
  };

  const renderFooterInformation = () => {
    return (
      <div>
        <div className="StoreBuilderPaymentModal__footer_information">
          <div>
            <img src={padlockGreyIcon} alt="Padlock Icon" />
            <span>
              <div>128-bit SSL encryption</div>
              <div>All your payment details are 100% safe with us.</div>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <ModalWrapper
      size="small"
      className="StoreBuilderPaymentModal__container"
      backdropClassName="StoreBuilderPaymentModal__backdrop"
    >
      <Loadable active={isFetching}>
        {/* START -  Header Modal */}
        {renderHeaderModal()}
        {/* END -  Header Modal */}

        <ModalWrapper.Body>
          {/* START -  Info Section */}
          <div className="StoreBuilderPaymentModal__info">
            <img src={checkmark} alt="checkmark" />
            <div>
              <strong>Beautifully designed store</strong>
              <span>
                (with 10 exclusive products included) - <strong>$19</strong>
              </span>
            </div>
          </div>

          {starterPlan() && (
            <div className="StoreBuilderPaymentModal__info ">
              <img src={checkmark} alt="checkmark" />
              <div className="StoreBuilderPaymentModal__info-row">
                <strong>
                  Access to Starter Plan - {starterPlan().trial_days} days trial
                </strong>{" "}
                then
                <strong> {starterPlan().price}/month</strong>, cancel anytime.
                Your first bill will be scheduled for
                <strong>
                  {" "}
                  {addDaystoCurrentDate(starterPlan().trial_days, "MMMM Do")}
                </strong>
              </div>
            </div>
          )}
          {/* END -  Info Section */}

          {/* START -  Price Section */}
          <div className="StoreBuilderPaymentModal__price">
            <div>To pay now</div>
            <div>$19</div>
          </div>
          {/* END -  Price Section */}

          {/* Start -  Payment Section */}
          <div className="StoreBuilderPaymentModal__section-name  mt-30">
            Payment details <img src={lock} alt="lock" />
          </div>
          <Tabs
            selectedIndex={0}
            className="StoreBuilderPaymentModal__payment-section"
          >
            <TabList>
              {/* START -  Credit Card Tab */}
              {renderCreditCardTab()}
              {/* END -  Credit Card Tab */}
            </TabList>

            <TabPanel>
              <div className="StoreBuilderPaymentModal__credit-card-info">
                <CreditCard
                  openCreditCardUpdate={!stripeCustomerId ? true : false}
                  hideButtons
                  afterSubmit={() =>
                    createPayment({ planId: starterPlan().id })
                  }
                  hideLabel={true}
                />
              </div>
            </TabPanel>
          </Tabs>
          {/* END -  Payment Section */}

          {/* START - Footer */}
          <div className="StoreBuilderPaymentModal__footer">
            {renderCheckoutButton()}

            <div className="StoreBuilderPaymentModal__agreement">
              By proceeding, you agree to the{" "}
              <Link target="_blank" to="/terms">
                Terms of Use
              </Link>,{" "}
              <Link target="_blank" to="/privacy">
                Privacy Policy
              </Link>, and
              <a
                href="https://help.spocket.co/en/articles/3018492-what-is-spocket-s-plan-subscription-refund-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                Refund Policy
              </a>
            </div>
          </div>
          {/* END - Footer */}
        </ModalWrapper.Body>
      </Loadable>
      {renderFooterInformation()}
    </ModalWrapper>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ createPayment }, dispatch);
}

function mapStateToProps(state) {
  const { store, upgrade, eventTracker, sharedComponents, settings } = state;

  return {
    isFetching:
      store.customBuildStorePayment.isFetching ||
      !store.plans.allPlans ||
      upgrade.isUpgrading,
    allPlans: store.plans.allPlans || [],
    tracker: sharedComponents.tracker,
    eventId: eventTracker.eventId,
    paymentProvider: settings.paymentProvider,
    proratedEmpireCost: settings.proratedEmpireCost,
    stripeCustomerId: state.settings.stripeCustomerId,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreBuilderPaymentModal);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/modalConductor/StoreBuilderPaymentModal.js